import React from 'react';
import { userAction } from '@/util/helpers/ajax-helpers';
import { useTimeoutToggle } from '../../hooks';
import styles from './CopyBox.module.scss';

export type CopyBoxProps = {
  value: string;
  className?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  notificationLifetime?: number;
  onClick?: () => void;
  text?: string;
  icon?: React.ReactNode;
};

export const CopyBox: React.FC<CopyBoxProps> = ({
  value,
  children,
  className = '',
  disabled = false,
  style = {},
  notificationLifetime = 2500,
  onClick,
  text = 'Copy',
  icon,
}) => {
  const [isNotificationShown, showNotification] =
    useTimeoutToggle(notificationLifetime);

  const handleCopyUrl = () => {
    window.navigator.clipboard
      .writeText(value)
      .then(() => {
        showNotification();
        userAction('use-copy-url');
        if (onClick) {
          onClick();
        }
      })
      .catch(() => window.alert('Oops, unable to copy'));
  };

  return (
    <div
      className={`input-group ${className}`}
      style={{ ...style, display: 'flex', flexDirection: 'row' }}
    >
      <input
        type="text"
        style={{
          flexGrow: 1,
          border: '1px solid #ddd',
          borderRadius: '4px',
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          backgroundColor: '#e9ecef',
          paddingLeft: '10px',
        }}
        value={value}
        readOnly
      />
      <button
        className={`btn btn-outline-dark position-relative ${
          icon ? styles.button : ''
        }`}
        type="button"
        onClick={handleCopyUrl}
        disabled={disabled}
      >
        {icon && <div className={styles.iconContainer}>{icon}</div>}
        {text}
        {isNotificationShown && (
          <span className="copied-notification">Copied!</span>
        )}
      </button>
      {children}
    </div>
  );
};
